// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-6b9dc70c]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}[data-v-6b9dc70c] .widget-content>div:last-child{max-width:1212px}.consecutive-widget .activity_content_desk[data-v-6b9dc70c]{padding:60px 0 40px}.consecutive-widget .activity_content_mobile[data-v-6b9dc70c]{padding:40px 0 40px 16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
